<template>
  <div class="col-lg-4">
    <v-card class="mx-auto">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-card-title
            class="headline grey lighten-3"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left> fal fa-pen-nib </v-icon>
            Assigned to You
          </v-card-title>
        </template>
        <span> Modules or playlists assigned to you. </span>
      </v-tooltip>
      <div class="kt-portlet kt-portlet--height-fluid kt-widget19">
        <section>
          <div class="kt-portlet__body" v-if="!isEmpty(assignedToYou)">
            <div class="tab-content">
              <div class="tab-pane active" id="kt_widget4_tab1_content">
                <div class="kt-widget4">
                  <div
                    class="kt-widget4__item"
                    v-for="(assigned, index) in assignedToYou"
                    :key="index"
                  >
                    <div class="kt-widget4__info">
                      <a
                        href="javascript:"
                        class="kt-widget4__username text-uppercase mb-1"
                      >
                        {{ assigned.name }}
                      </a>
                      <p class="kt-widget4__text">
                        Assigned By:
                        <span class="kt-font-bolder">{{
                          assigned.assigned_by
                        }}</span>
                      </p>
                      <p class="kt-widget4__text">
                        Due Date:
                        <span
                          class="kt-font-bolder"
                          :class="dueDateTextColor(assigned.due_date)"
                        >
                          {{ assigned.due_date }}
                        </span>
                      </p>
                      <p class="kt-widget4__text mt-1">
                        <v-chip class="ml-1 yellow darken-3 mt-2" small
                          >{{ assigned.type }}
                        </v-chip>
                      </p>
                    </div>
                    <v-btn :to="assigned.url" text color="primary" small>
                      <v-icon class="mr-2" small>fa fa-external-link</v-icon>
                      View
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <p class="ml-3 my-3" style="color: #595d6e">
              You currently don't have any assigned modules.
            </p>
          </div>
        </section>
      </div>
    </v-card>
  </div>
</template>
<script>
import { isEmpty as _isEmpty } from 'lodash-es';
import dayjs from 'dayjs';

export default {
  name: 'AssignedModule',
  data: () => ({
    loading: true,
    assignedToYou: [],
    isEmpty: _isEmpty,
  }),

  created() {
    this.loadModules();
  },

  methods: {
    loadModules() {
      this.$store
        .dispatch('lmsClient/getLatestAssigned')
        .then(({ data }) => {
          this.loading = false;
          this.assignedToYou = data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    dueDateTextColor(date) {
      const today = dayjs();
      const parsedDate = dayjs(date);

      if (parsedDate.isAfter(today, 'day')) {
        return 'kt-font-success';
      }

      if (parsedDate.isSame(today, 'day')) {
        return 'kt-font-warning';
      }

      return 'kt-font-danger';
    },
  },
};
</script>
<style lang="stylus" scoped>
.kt-widget19 .kt-widget19__wrapper .kt-widget19__content .kt-widget19__info
  padding-left 0px

.module-image
  width 95%
  margin auto
  background-image url('https://i.imgur.com/EGqO9i5.jpg') //default image
  //background image should be replaced by the module banner set in module creation
</style>
